import { render } from "./ColorPallette.vue?vue&type=template&id=5b9c85ce&scoped=true"
import script from "./ColorPallette.vue?vue&type=script&lang=js"
export * from "./ColorPallette.vue?vue&type=script&lang=js"

import "./ColorPallette.vue?vue&type=style&index=0&id=5b9c85ce&scoped=true&lang=css"
import "./ColorPallette.vue?vue&type=style&index=1&id=5b9c85ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9c85ce"]])

export default __exports__